import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { endpoints } from '../../constants/endpoints';
import * as Act from './application.actions';
import { IBulkAddState } from 'src/app/inventory/interfaces/bulk-add-state.interface';
import { IUnfinishedAuditState } from 'src/app/audits/interfaces/unfinished-audit-state.interface';

export interface ApplicationStateModel {
  loading: boolean;
  success: boolean;
  bulkAddInventorySnapshot: IBulkAddState;
  auditState: IUnfinishedAuditState;
}

@State<ApplicationStateModel>({
  name: 'application',
})

@Injectable()
export class ApplicationState {

  constructor(
    private http: HttpClient,
    private store: Store,
  ) {
  }

  @Selector()
  static loading(state: ApplicationStateModel): boolean {
    return state.loading;
  }

  @Selector()
  static success(state: ApplicationStateModel): boolean {
    return state.success;
  }

  @Selector()
  static bulkAddInventorySnapshot(state: ApplicationStateModel): IBulkAddState {
    return state.bulkAddInventorySnapshot;
  }

  @Selector()
  static auditState(state: ApplicationStateModel): IUnfinishedAuditState {
    return state.auditState;
  }

  @Action(Act.SaveBulkAddInventorySnapshot)
  saveBulkAddInventoryState(ctx: StateContext<ApplicationStateModel>, {state}: Act.SaveBulkAddInventorySnapshot): Observable<any> {
    ctx.patchState({loading: true, bulkAddInventorySnapshot: state});

    return this.http.post(endpoints.clientState.createOrUpdateBulkAddState, state)
    .pipe(
      tap((responseData: any) => {
        ctx.patchState({
          loading: false,
        });
      }),
      catchError((err) => {
        ctx.patchState({loading: false});
        return of(null);
      }),
    );
  }

  @Action(Act.GetBulkAddInventorySnapshot)
  getBulkAddInventoryState(ctx: StateContext<ApplicationStateModel>, {}: Act.GetBulkAddInventorySnapshot): Observable<IBulkAddState> {
    ctx.patchState({loading: true});

    return this.http.get(endpoints.clientState.getBulkAddState)
    .pipe(
      tap((responseData: any) => {
        ctx.patchState({
          loading: false,
          bulkAddInventorySnapshot: responseData?.value
        });
      }),
      catchError((err) => {
        ctx.patchState({loading: false});
        return of(null);
      }),
    );
  }

  @Action(Act.SaveUnfinishedAuditState)
  saveUnfinishedAuditState(ctx: StateContext<ApplicationStateModel>, {state}: Act.SaveUnfinishedAuditState): Observable<any> {
    ctx.patchState({loading: true, auditState: state});

    return this.http.post(endpoints.clientState.createOrUpdateAuditState, state)
    .pipe(
      tap((responseData: any) => {
        ctx.patchState({
          loading: false,
        });
      }),
      catchError((err) => {
        ctx.patchState({loading: false});
        return of(null);
      }),
    );
  }

  @Action(Act.GetUnfinishedAuditState)
  getUnfinishedAuditState(ctx: StateContext<ApplicationStateModel>, {id}: Act.GetUnfinishedAuditState): Observable<void> {
    ctx.patchState({loading: true});

    return this.http.get(endpoints.clientState.getAuditState + id)
    .pipe(
      tap((responseData: any) => {
        ctx.patchState({
          loading: false,
          auditState: responseData?.value
        });
      }),
      catchError((err) => {
        ctx.patchState({loading: false});
        return of(null);
      }),
    );
  }

}
